import React from "react";
import Matomo from "oc-app/Matomo";
import { FooterButtons } from "./FooterButtons";
import { createPortal } from "react-dom";

/**
 * Automatisches Sidescrolling Menü
 *
 * Children die die prop hide=true gesetzt haben werden ignoriert (so kann man Menüeinträge an Bedingungen knüpfen)
 * Titel der Buttons werden aus den Props der Children übernommen (child prop title)
 */
export class OptionMenu extends React.Component {
  constructor(props) {
    super(props);
    APP.optionMenu = this;

    this.state = {
      selectedIndex: 0,
      minimized: false,
      showMenu: false,
      fullView: window.innerWidth >= 600,
    };
    this.visitedContent = [0];
    this.lastItem = 0;

    window.addEventListener("resize", () => this.onResize());
    this.onResize();
  }

  onResize() {
    const newFullView = window.innerWidth >= 600;
    if (newFullView != this.state.fullView) this.setState({ fullView: newFullView });
  }

  selectItem = (index) => {
    if (!isNaN(index)) {
      index = _.clamp(index, 0, this.getCurrentChildren().length - 1);
      const lastIndex = this.state.selectedIndex;
      this.visitedContent.push(lastIndex);
      this.visitedContent = _.uniq(this.visitedContent);

      this.setState({ selectedIndex: index, minimized: false, showMenu: false }, () => {
        const children = this.getCurrentChildren();
        APP.trigger("menuSelect", index, lastIndex, children[index]?.key);

        // Nach Wechsel, den Fokus auf die neue Section setzen
        if (lastIndex !== index) {
          setTimeout(() => {
            const newSection = document.querySelector(`#optionMenuContent section.selectedContent`);
            if (newSection) {
              newSection.focus();
            }
          }, 50);
        }
      });

      if (lastIndex != index) {
        setTimeout(() => {
          const pageTitle = document.querySelector(".mainButton .label").innerText;
          Matomo.page("Menu" + (index + 1), pageTitle);
          APP.updateMenuContainerHeight();
        }, 100);
      }
    }
  };

  selectItemByKey(key) {
    const index = this.getCurrentChildren().findIndex((child) => child.key == key);
    this.selectItem(index);
  }

  nextItem = () => {
    this.selectItem(this.state.selectedIndex + 1);
  };

  isLastItem = () => {
    return this.state.selectedIndex == this.lastItem;
  };

  toggleMinimize = () => {
    this.setState((prevState) => ({
      minimized: !prevState.minimized,
    }));
  };

  openMenu = () => {
    this.setState({ showMenu: true });
  };

  closeMenu = () => {
    if (this.state.showMenu) this.setState({ showMenu: false });
  };

  startWithStep(step) {
    if (step < 0 || isNaN(step)) {
      console.warn("Ungültiger Schritt, ignoriere Parameter c.step=", step);
      return;
    }
    for (let i = 0; i < step; i++) this.visitedContent.push(i);

    this.selectItem(step);
  }

  componentDidMount() {
    // Fix für zerstörtes Menü. Keiner weiß wie es passiert, aber so sollte es sich fixen lassen.
    // Hervorrufen konnte man das Problem indem man im Element-Tab der Browser-Konsole etwas sucht was nicht im View ist.
    document
      .getElementById("optionMenu")
      .addEventListener("scroll", (e) => (e.target.scrollLeft = 0));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.fullView) {
      setTimeout(() => {
        const mainMenuEl = document.querySelector("#optionMenuHeader .mainMenu");
        const allMenuItemsEl = document.querySelector("#optionMenuHeader .mainMenu .allMenuItems");
        let selectedItemIndex = this.state.selectedIndex == 0 ? 0 : this.state.selectedIndex - 1;
        if (selectedItemIndex >= allMenuItemsEl.children.length) {
          selectedItemIndex = allMenuItemsEl.children.length - 1;
          this.selectItem(selectedItemIndex);
        }

        const selectedItemEl = allMenuItemsEl.children[Math.min(selectedItemIndex)];
        const currentMenuLeft = allMenuItemsEl.offsetLeft;
        const currentItemLeft = selectedItemEl.offsetLeft;
        const relativeLeft = currentItemLeft - currentMenuLeft;

        const newScrollLeft = relativeLeft;
        mainMenuEl.scrollLeft = newScrollLeft;
      }, 100);
    }
  }

  getCurrentChildren() {
    return this.props.children.filter((x) => x && !x.props.hide);
  }

  getCurrentKey() {
    return this.getCurrentChildren()[this.state.selectedIndex]?.key;
  }

  render() {
    const children = this.getCurrentChildren();
    const numberOfChildren = children.length;

    const label = children.map((child) => child.props?.title || "NO TITLE");
    this.lastItem = label.length - 1;

    return (
      <div
        id="optionMenu"
        role="region"
        aria-label={I18N("Optionen Menü")}
        className={`${this.state.fullView ? "fullView" : ""}${
          this.state.minimized ? "minimized" : ""
        }`}
        onClick={this.closeMenu}
      >
        {createPortal(
          <header
            id="optionMenuHeader"
            className="noselect"
            role="navigation"
            aria-label={I18N("Hauptnavigation")}
          >
            {this.state.selectedIndex > 0 ? (
              <button
                aria-label={I18N("Zurück")}
                onClick={() => this.selectItem(this.state.selectedIndex - 1)}
                className="backButton button clickable fading"
                title={I18N("Zurück")}
              >
                <span>
                  <span className="icon icon-chevron-left" aria-hidden="true"></span> &nbsp;&nbsp;{" "}
                  {I18N("Zurück")}
                </span>
              </button>
            ) : (
              <div
                className="backButton button"
                aria-hidden="true"
                style={{ cursor: "default" }}
              ></div>
            )}
            <div className="mainMenu button clickable">
              <button
                className={`mainButton fading  ${this.state.fullView ? "hidden" : ""}`}
                aria-haspopup="menu"
                aria-expanded={this.state.showMenu || this.state.fullView}
                aria-controls="allMenuItems"
                aria-label={I18N("Menü öffnen:") + label[this.state.selectedIndex]}
                onClick={() => this.openMenu()}
              >
                <span className="label" aria-hidden="true">
                  {label[this.state.selectedIndex]}
                </span>
                <span className="burgerButton" aria-hidden="true">
                  ☰
                </span>
              </button>
              <ul
                id="allMenuItems"
                className={`allMenuItems ${
                  this.state.showMenu || this.state.fullView ? "" : "hidden"
                }`}
                role="menu"
                aria-label={I18N("Konfigurationsschritte")}
              >
                {label.map((label, index) => (
                  <li key={label + index} role="none">
                    <button
                      role="menuitem"
                      aria-current={this.state.selectedIndex == index ? "step" : "false"}
                      aria-label={`${I18N("MASS_MENU_" + label)}${this.visitedContent.indexOf(index) > -1 ? " - " + I18N("abgeschlossen") : ""}`}
                      className={`button clickable fading ${
                        this.state.selectedIndex == index ? "selected" : ""
                      }`}
                      onClick={() => this.selectItem(index)}
                    >
                      <span aria-hidden="true">{I18N("MASS_MENU_" + label)}</span>
                      {this.visitedContent.indexOf(index) > -1 && (
                        <i className="icon icon-check" aria-hidden="true"></i>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            {this.isLastItem() ? (
              <div className="nextButton" aria-hidden="true" style={{ cursor: "default" }}></div>
            ) : (
              <button
                aria-label={I18N("Zum nächsten Schritt")}
                onClick={() => this.selectItem(this.state.selectedIndex + 1)}
                className="nextButton button clickable fading"
                title={I18N("Weiter")}
              >
                <span>
                  {I18N("Weiter")} &nbsp;&nbsp;{" "}
                  <span className="icon icon-chevron-right" aria-hidden="true"></span>
                </span>
              </button>
            )}
          </header>,
          document.getElementById("grid-menu")
        )}
        <main
          id="optionMenuContent"
          aria-live="polite"
          aria-atomic="false"
          aria-label={I18N("Konfigurationsinhalt")}
          style={{
            width: numberOfChildren * 100 + "%",
            transform: `translateX(${(-this.state.selectedIndex * 100) / numberOfChildren}%`,
          }}
        >
          {children.map((child, index) => {
            const isSelected = this.state.selectedIndex == index;
            return (
              <section
                key={"optionMenuContentChild" + index}
                aria-label={`${I18N("Schritt")} ${index + 1}: ${label[index]}`}
                aria-hidden={!isSelected}
                inert={isSelected ? undefined : ""}
                className={isSelected ? "selectedContent" : ""}
                tabIndex={-1}
              >
                {child}
              </section>
            );
          })}
        </main>
        {this.props.showFooter && (
          <footer
            id="optionMenuFooter"
            role="group"
            aria-label={I18N("Menü-Fußzeile")}
            className="noselect"
          >
            {this.props.showMinimize && (
              <button
                aria-pressed={this.state.minimized}
                aria-label={
                  this.state.minimized ? I18N("Menü maximieren") : I18N("Menü minimieren")
                }
                className="minimizeButton button clickable fading"
                onClick={this.toggleMinimize}
                title={this.state.minimized ? I18N("Maximieren") : I18N("Minimieren")}
              >
                <span
                  className={"icon " + (this.state.minimized ? "icon-plus" : "icon-minus")}
                  aria-hidden="true"
                ></span>
              </button>
            )}
            <FooterButtons></FooterButtons>
          </footer>
        )}
        {this.state.minimized ? (
          <div id="optionMenuInvisibleExtraSpace" aria-hidden="true"></div>
        ) : null}
      </div>
    );
  }
}
